import OrganizationsProjects from "../controllers/Organization/OrganizationsProjects";
import { parseFilter } from "colbi_web_ui/lib/utils";
const queries = (args) => {
    const { filter, organizationId } = args;

    const queriesWithOrgId = [
        {
            resource: "organization_projects",
            args: {
                filter: filter ? { type: "[FilterInput!]", value: parseFilter(filter) } : undefined,
                organizationId: organizationId,
            },
            body: "id,name,maxFiscalYear,fiscalYears,calendarYears,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,aggregationDataResult,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired,organizationActive,",
            forceRefresh: true,
        },
        {
            resource: "user_projects_organizations_filters",
            args: {
                organizationId: organizationId,
            },
            body: "prop, name, type, list, disableOperators, mandatory",
            forceRefresh: true,
        },
    ];

    return [...queriesWithOrgId].filter((r) => r);
};

const userProjectsByOrganization = (path, navigation, exact, title) => ({
    path,
    navigation: navigation,
    component: OrganizationsProjects,
    queries,
    exact,
    title: [`label(${title})`],
});

export default userProjectsByOrganization;
